import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAuthState } from "../../../interfaces/store/auth-interfaces";
import { IError } from "../../../interfaces/base";

const initialState: IAuthState = {
  user: null,
  loginForm: null,
  loading: false,
  error: null,
  authenticated: false,
  secret: null,
  authCheck: true,
  requestState: "prepare",
  operation: null,
  forgotPassword: false,
};

const _loginRequest = (state: IAuthState, { payload }: PayloadAction<any>) => {
  state.loginForm = payload;
  state.user = null;
  state.authenticated = false;
  state.loading = true;
  state.error = null;
  state.authCheck = true;
};

const _loginSuccess = (state: IAuthState, action: PayloadAction<any>) => {
  state.loading = false;
  state.user = action.payload;
  state.authenticated = true;
  state.error = null;
  state.authCheck = false;
};

const _loginFailure = (state: IAuthState, action: PayloadAction<IError>) => {
  state.loading = false;
  state.error = action.payload;
  state.authenticated = false;
  state.authCheck = false;
};

const _authCheckStart = (state: IAuthState) => {
  state.user = null;
  state.authenticated = false;
  state.loading = true;
  state.error = null;
  state.authCheck = true;
};

const _authCheckSuccess = (
  state: IAuthState,
  { payload }: PayloadAction<any>
) => {
  // state.user = payload.user;
  // console.log('AuthCheckSuccess:', payload);
  state.authenticated = true;
  state.loading = false;
  state.error = null;
  state.authCheck = false;
};

const _removeAecret = (state: IAuthState) => {
  state.secret = null;
};

const _authCheckFailed = (
  state: IAuthState,
  { payload }: PayloadAction<any>
) => {
  state.authenticated = false;
  state.loading = false;
  state.error = payload;
  state.authCheck = false;
};

const _authLogoutStart = (state: IAuthState) => {
  state.loading = true;
  state.error = null;
};

const _authLogoutSuccess = (state: IAuthState) => {
  state.user = null;
  state.authenticated = false;
  state.loading = false;
  state.error = null;
  state.authCheck = false;
};

const _failed = (state: IAuthState, { payload }: PayloadAction<IError>) => {
  state.loading = false;
  state.error = payload;
};

const _getUserInfo = (state: IAuthState) => {};

const _forgotPasswordStart = (
  state: IAuthState,
  { payload }: PayloadAction<{ email: string }>
) => {
  state.loading = true;
  state.error = null;
  state.forgotPassword = true;
  state.requestState = "start";
};

const _forgotPasswordSuccess = (
  state: IAuthState,
  { payload }: PayloadAction<any>
) => {
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _forgotPasswordFailed = (
  state: IAuthState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.requestState = "error";
};

const _resetForgotPassword = (state: IAuthState) => {
  state.loading = false;
  state.error = null;
  state.forgotPassword = false;
  state.requestState = "prepare";
};

const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginRequest: _loginRequest,
    loginSuccess: _loginSuccess,
    loginFailure: _loginFailure,
    authCheckStart: _authCheckStart,
    authCheckSuccess: _authCheckSuccess,
    authCheckFailed: _authCheckFailed,
    authLogoutStart: _authLogoutStart,
    authLogoutSuccess: _authLogoutSuccess,
    failed: _failed,
    getUserInfo: _getUserInfo,
    forgotPasswordStart: _forgotPasswordStart,
    forgotPasswordSuccess: _forgotPasswordSuccess,
    forgotPasswordFailed: _forgotPasswordFailed,
    resetForgotPassword: _resetForgotPassword,
  },
});

const { actions, reducer } = AuthSlice;

export const {
  loginRequest,
  loginSuccess,
  loginFailure,
  authCheckStart,
  authCheckSuccess,
  authCheckFailed,
  authLogoutStart,
  authLogoutSuccess,
  failed,
  getUserInfo,
  forgotPasswordStart,
  forgotPasswordSuccess,
  forgotPasswordFailed,
  resetForgotPassword,
} = actions;

export default reducer;
